// Dashed placeholder shown under a chart section header while the report is
// still loading, or when the selected range genuinely has no rows — so the
// section never renders as a bare white gap. Mirrors the temperature page's
// inline loading/empty state; the caller decides `loading` (report not fetched
// yet) vs empty (fetched, no rows). The loading state is an animated spinner
// (amber, matching the app theme) over the text so it reads as active work,
// not a stalled empty box.
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface Props {
  loading: boolean;
  loadingText: string;
  emptyText: string;
  height?: number;
}

const amberSpin = (
  <LoadingOutlined style={{ fontSize: 30, color: "#febc11" }} spin />
);

export default function ChartPlaceholder({
  loading,
  loadingText,
  emptyText,
  height = 220,
}: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        height,
        border: "1px dashed #e2e8f0",
        borderRadius: 12,
        margin: "18px 0 0",
        color: "#94a3b8",
        fontSize: 14,
      }}
    >
      {loading ? (
        <>
          <Spin indicator={amberSpin} />
          <span>{loadingText}</span>
        </>
      ) : (
        emptyText
      )}
    </div>
  );
}
